/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MilestoneDto } from './MilestoneDto';
import {
    MilestoneDtoFromJSON,
    MilestoneDtoFromJSONTyped,
    MilestoneDtoToJSON,
    MilestoneDtoToJSONTyped,
} from './MilestoneDto';

/**
 * 
 * @export
 * @interface POAMItemDto
 */
export interface POAMItemDto {
    /**
     * 
     * @type {string}
     * @memberof POAMItemDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMItemDto
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMItemDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMItemDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMItemDto
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof POAMItemDto
     */
    dueDate?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof POAMItemDto
     */
    relatedFindings?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof POAMItemDto
     */
    remarks?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMItemDto
     */
    implementedRequirementUuid?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMItemDto
     */
    budget?: string;
    /**
     * 
     * @type {Array<MilestoneDto>}
     * @memberof POAMItemDto
     */
    milestones?: Array<MilestoneDto>;
}

/**
 * Check if a given object implements the POAMItemDto interface.
 */
export function instanceOfPOAMItemDto(value: object): value is POAMItemDto {
    return true;
}

export function POAMItemDtoFromJSON(json: any): POAMItemDto {
    return POAMItemDtoFromJSONTyped(json, false);
}

export function POAMItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): POAMItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'status': json['status'] == null ? undefined : json['status'],
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'relatedFindings': json['relatedFindings'] == null ? undefined : json['relatedFindings'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'implementedRequirementUuid': json['implementedRequirementUuid'] == null ? undefined : json['implementedRequirementUuid'],
        'budget': json['budget'] == null ? undefined : json['budget'],
        'milestones': json['milestones'] == null ? undefined : ((json['milestones'] as Array<any>).map(MilestoneDtoFromJSON)),
    };
}

export function POAMItemDtoToJSON(json: any): POAMItemDto {
    return POAMItemDtoToJSONTyped(json, false);
}

export function POAMItemDtoToJSONTyped(value?: POAMItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'uuid': value['uuid'],
        'title': value['title'],
        'description': value['description'],
        'status': value['status'],
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'relatedFindings': value['relatedFindings'],
        'remarks': value['remarks'],
        'implementedRequirementUuid': value['implementedRequirementUuid'],
        'budget': value['budget'],
        'milestones': value['milestones'] == null ? undefined : ((value['milestones'] as Array<any>).map(MilestoneDtoToJSON)),
    };
}

